import { render, staticRenderFns } from "./ReserveMenu.vue?vue&type=template&id=0a1b9051"
import script from "./ReserveMenu.vue?vue&type=script&lang=js"
export * from "./ReserveMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports